<template>
    <div>
       <HeaderTeam header="ตารางการทำงาน" :img_header="header_image" link_back="team"/>
       <MenuTeamWorkScheduleList/>
       <ManageWorkScheduleList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/schedule_1.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamWorkScheduleList from '@/components/menuadmin/team/teamworkschedule/MenuTeamWorkScheduleList.vue'
import ManageWorkScheduleList from '@/components/menuadmin/team/teamworkschedule/ManageWorkScheduleList.vue'
export default {
    name:'manageWorkSchedule',
    components:{
        HeaderTeam,
        MenuTeamWorkScheduleList,
        ManageWorkScheduleList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>